import { render, staticRenderFns } from "./VHtmlPanel.vue?vue&type=template&id=2cd90d4f&"
import script from "./VHtmlPanel.vue?vue&type=script&lang=js&"
export * from "./VHtmlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports